import { styled } from "@mui/material";

export const OrdersContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: "1.5rem",
});

export const TableStyle = styled("div")({
  border: "1px solid #E4E7EC",
  borderRadius: "8px",
  "& thead th": {
    background: "#FCFCFD",
    boxShadow: "0px -1px 0px 0px #CCDEEE inset",
    color: "#1D2939",
    fontFamily: "Manrope",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: "700",
    lineHeight: "16px",
    letterSpacing: "0.5px",
  },
  "& tbody": {
    "& table": {
      "& thead th": {
        background: "#f1f6fB",
      },
      "& tbody tr:nth-of-type(even)": {
        background: "#f7f7f7",
      },
    },
  },
});
